import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../config';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DnevniPlanService {

  constructor(private _http: HttpClient) { }

  dnevniPlan(a: any) {
    return this._http.post(AppConfig.ipAddress + 'planproizvodnjepodanima_prikaz', a)
      .pipe(map((res: any) => res));
  }

  dohvatiSveLinije(a: any) {
    return this._http.post(AppConfig.ipAddress + 'dohvati_sve_linije', a)
      .pipe(map((res: any) => res));
  }

  dohvatiSveProizvode(a: any) {
    return this._http.post(AppConfig.ipAddress + 'dohvati_sve_artikle', a)
      .pipe(map((res: any) => res));
  }

  dodavanjeBezNarudzbe(a: any) {
    return this._http.post(AppConfig.ipAddress + 'dodavanje_plana_proizvodnje_bez_narudzbe', a)
      .pipe(map((res: any) => res));
  }

  uredjivanjeBezNarudzbe(a: any) {
    return this._http.post(AppConfig.ipAddress + 'uredivanje_plana_proizvodnje_bez_narudzbe', a)
      .pipe(map((res: any) => res));
  }

  brisanjeBezNarudzbe(a: any) {
    return this._http.post(AppConfig.ipAddress + 'brisanje_plana_nijenalog', a)
      .pipe(map((res: any) => res));
  }

  dohvatiPartnere(a: any) {
    return this._http.post(AppConfig.ipAddress + 'dohvati_sve_partnere', a)
      .pipe(map((res: any) => res));
  }

  provjeraPaleta(a: any) {
    return this._http.post(AppConfig.ipAddress + 'dohvati_polovicne_palete', a)
      .pipe(map((res: any) => res));
  }

  provjeraLinija(a: any) {
    return this._http.post(AppConfig.ipAddress + 'dohvati_linje_za_artikl', a)
      .pipe(map((res: any) => res));
  }

  maksimumLinije(a: any) {
    return this._http.post(AppConfig.ipAddress + 'dohvati_max_kolicinu_linije', a)
      .pipe(map((res: any) => res));
  }

  provjeraProizvodaNaAkciji(a: any) {
    return this._http.post(AppConfig.ipAddress + 'provjera_proizvoda_na_akciji', a)
      .pipe(map((res: any) => res));
  }

  dohvatiDjelatnike(a: any) {
    return this._http.post(AppConfig.ipAddress + 'dohvati_sve_djelatnike', a)
      .pipe(map((res: any) => res));
  }

  tjedanUGodini(a: any) {
    return this._http.post(AppConfig.ipAddress + 'tjedan_u_godini', a)
      .pipe(map((res: any) => res));
  }
  
  pravaKorisnika(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'prijavaprava', a)
      .pipe(map((res: any) => res));
  }

  dohvatiArtikleUCjenikuZaPartnera(a: any) {
    return this._http
    .post(AppConfig.ipAddress + 'artikli_u_cjeniku_za_partnera', a)
    .pipe(map((res: any) => res));
  }
}
